import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { FormSelect } from "source/app/presentation/Shared/Form/Select/FormSelect";
import { FormTextArea } from "source/app/presentation/Shared/Form/TextArea/FormTextArea";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { ReadState } from "source/app/services/UI/State/ReadState";
import { SetState } from "source/app/services/UI/State/SetState";
import { IPhrasingState } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/Phrasing/Phrasing";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";

export function PhrasingHeader() {
    const state = ReadState<IPhrasingState>(ESharedFunction.Phrasing_state);

    if (!state) {
        return null;
    }

    const setState = (newState: Partial<IPhrasingState>) =>
        SetState<IPhrasingState>(ESharedFunction.Phrasing_state, newState);

    return (
        <div>
            <div>
                <span>I am afraid that</span>
                <FormTextArea
                    id="clickTarget_phrasingHeaderProblem"
                    width="200px"
                    onChange={(value) => setState({ headerProblem: value })}
                    value={state.headerProblem}
                    classes={StyleClass(`phrasingHeaderProblem`, {
                        position: "relative",
                        top: "13px",
                    })}
                />
                <FormSelect
                    width="40px"
                    id="phrasingHeaderDifficulty"
                    onChange={(event) =>
                        setState({
                            headerDifficulty: Number.parseInt(
                                event.target.value
                            ),
                        })
                    }
                    onEnter={(value) => {
                        Book(setState, state, value);

                        document
                            .getElementById("clickTarget_phrasingBodyPart")!
                            .focus();
                    }}
                    suggestions={[1, 2, 3, 4, 5, 6, 7, 8, 9].map((v) =>
                        v.toString()
                    )}
                    value={state.headerDifficulty}
                />
                <IconWithText
                    iconSuffix={EGlyphicon.ok}
                    whenClicked={() =>
                        Book(setState, state, state.headerDifficulty)
                    }
                    displayAsBlock={false}
                    withClass={StyleClass(`phrasingBodyBookLink`, {
                        opacity: 0.6,
                        marginLeft: `10px`,
                    })}
                >
                    Book
                </IconWithText>
            </div>
        </div>
    );
}

function Book(
    setState: (newState: Partial<IPhrasingState>) => Promise<void>,
    state: IPhrasingState,
    value: string | number
) {
    setState({
        bodyTexts: [
            ...state.bodyTexts,
            `I'm afraid that ${state.headerProblem} (${value})`,
        ],
    });
}
